<div *ngIf="!isMobile" class="stock-list-container ml-2 mr-2 mb-2">
  <!-- Cabeçalho -->
    <div class="stock-header -mb-5">
        <div class="left-buttons">
            <div
                class="flex pr-5 md:pr-0 items-center font-sans text-xl text-neutral-500 font-bold">
                <mat-icon class="text-orange-500">inventory_2</mat-icon> &nbsp; <spam class="text-green-700">Estoques </spam>
            </div>                 
        </div>
      <div class="right-buttons flex gap-2 flex-wrap">
        <button mat-flat-button color="primary" (click)="switchTab()" [disabled]="isLoading || isDownloading">
          <mat-icon>dashboard</mat-icon>
          <span>&nbsp; Dashboard Estoques</span>
        </button>

        <button mat-flat-button color="primary" (click)="downloadStock()" [disabled]="isLoading || isDownloading">
          <mat-icon>cloud_download</mat-icon>
        </button>

        <button mat-flat-button color="primary" (click)="openFilterDialog()" [disabled]="isLoading || isDownloading">
          <mat-icon>search</mat-icon>
          <span>Filtrar</span>
        </button>

        <button mat-flat-button color="primary" (click)="createNewStock()" [disabled]="isLoading || isDownloading">
          <mat-icon>add</mat-icon>
          <span>Criar Novo Estoque</span>
        </button>
      </div>
    </div>  
    
    <!-- Container branco para busca e legenda -->
    <div class="busca-legenda-container shadow-sm rounded-lg bg-white px-4 py-4 mt-4 mb-4">
    
      <div class="stock-header">
          <div class="left-buttons">           
              <div
                  *ngIf="filteredStock.length > 0" class="flex pr-5 md:pr-0 items-center font-sans text-sm text-neutral-500">
                  ✔️ Estoques encontrados: &nbsp; <spam class="text-green-700"><strong>{{ filteredStock.length }}</strong></spam>
              </div>  
              <div
                  *ngIf="filteredStock.length === 0" class="flex pr-5 md:pr-0 items-center font-sans text-sm text-neutral-500">
                  ❕ Estoques encontrados: &nbsp; <spam class="text-gray-700"><strong>{{ filteredStock.length }}</strong></spam>
              </div>       
          </div>
        <div class="right-buttons">          
        </div>
      </div> 

      <div class="stock-search-bar">
        <mat-form-field appearance="outline" class="search-input" floatLabel="never">
          <mat-label>Buscar</mat-label>
          <input matInput [(ngModel)]="searchTerm" placeholder="Digite para filtrar..." />
          <button mat-icon-button *ngIf="searchTerm" matSuffix (click)="searchTerm=''">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>
      </div>

      <!-- Legenda dos alertas -->
      <!-- Legenda dos alertas compacta -->
      <div class="px-2 text-xs text-gray-700 ml-2"> <!-- ⬅️ text-xs -->
        <div class="font-semibold mb-2 text-green-700">Legenda de Alertas</div>
        <div class="flex flex-wrap items-center gap-x-2 gap-y-1"> <!-- ⬅️ Menor gap -->

          <!-- Alerta 1 -->
          <div class="flex items-center gap-1">
            <mat-icon class="text-yellow-500" style="font-size: 14px;">report_problem</mat-icon>
            <span>Atenção</span>
          </div>

          <span class="px-1 text-gray-400">-</span>

          <!-- Alerta 2 -->
          <div class="flex items-center gap-1">
            <mat-icon class="text-yellow-600" style="font-size: 14px;">error</mat-icon>
            <span>Atualização há mais de 30 dias</span>
          </div>

          <span class="px-1 text-gray-400">-</span>

          <!-- Alerta 3 -->
          <div class="flex items-center gap-1">
            <mat-icon class="text-red-600" style="font-size: 14px;">warning</mat-icon>
            <span>Validade próxima ou vencida</span>
          </div>

          <span class="px-1 text-gray-400">-</span>

          <!-- Alerta 4 -->
          <div class="flex items-center gap-1">
            <div class="w-3 h-3 rounded-sm border-l-4 border-red-600 bg-red-100"></div>
            <span>Validade crítica</span>
          </div>

          <span class="px-1 text-gray-400">-</span>

          <!-- Alerta 5 -->
          <div class="flex items-center gap-1">
            <div class="w-3 h-3 rounded-sm border-l-4 border-yellow-400 bg-yellow-100"></div>
            <span>Sem atualização há 15+ dias</span>
          </div>

          <span class="px-1 text-gray-400">-</span>

          <!-- Alerta 6 -->
          <div class="flex items-center gap-1">
            <div class="w-3 h-3 rounded-sm border-l-4 border-yellow-600 bg-yellow-200"></div>
            <span>Sem atualização há 30+ dias</span>
          </div>

        </div>
      </div>

    </div>

    <mat-progress-bar *ngIf="isDownloading || isLoading" mode="indeterminate"></mat-progress-bar>

    <div class="table-wrapper">
      <table class="stock-table">
        <thead>
          <tr>
            <th (click)="sortBy('id')" style="width: 70px; text-align: center;">
              <div class="sortable-header col-id">
                <span>#ID</span>
                <mat-icon>
                  {{
                    sort.column === 'id'
                      ? (sort.direction === 'asc' ? 'arrow_upward' : 'arrow_downward')
                      : 'unfold_more'
                  }}
                </mat-icon>
              </div>
            </th>

            <th (click)="sortBy('farm')" style="width: 300px; text-align: left;">
              <div class="sortable-header col-farm">
                <span>Fazenda</span>
                <mat-icon>
                  {{
                    sort.column === 'farm'
                      ? (sort.direction === 'asc' ? 'arrow_upward' : 'arrow_downward')
                      : 'unfold_more'
                  }}
                </mat-icon>
              </div>
            </th>

            <th (click)="sortBy('product')" style="width: 220px; text-align: left;">
              <div class="sortable-header col-product">
                <span>Produto</span>
                <mat-icon>
                  {{
                    sort.column === 'product'
                      ? (sort.direction === 'asc' ? 'arrow_upward' : 'arrow_downward')
                      : 'unfold_more'
                  }}
                </mat-icon>
              </div>
            </th>

            <th (click)="sortBy('min')" style="width: 120px; text-align: center;">
              <div class="sortable-header col-min">
                <span>Nível Mín.</span>
                <mat-icon>
                  {{
                    sort.column === 'min'
                      ? (sort.direction === 'asc' ? 'arrow_upward' : 'arrow_downward')
                      : 'unfold_more'
                  }}
                </mat-icon>
              </div>
            </th>

            <th (click)="sortBy('total')" style="width: 120px; text-align: center;">
              <div class="sortable-header col-total">
                <span>Total</span>
                <mat-icon>
                  {{
                    sort.column === 'total'
                      ? (sort.direction === 'asc' ? 'arrow_upward' : 'arrow_downward')
                      : 'unfold_more'
                  }}
                </mat-icon>
              </div>
            </th>

            <th (click)="sortBy('batch')">
              <div class="sortable-header col-batch">
                <span>Lote</span>
                <mat-icon>
                  {{
                    sort.column === 'batch'
                      ? (sort.direction === 'asc' ? 'arrow_upward' : 'arrow_downward')
                      : 'unfold_more'
                  }}
                </mat-icon>
              </div>
            </th>

            <th (click)="sortBy('validity')" style="width: 180px; text-align: left;">
              <div class="sortable-header col-validity">
                <span>Validade</span>
                <mat-icon>
                  {{
                    sort.column === 'validity'
                      ? (sort.direction === 'asc' ? 'arrow_upward' : 'arrow_downward')
                      : 'unfold_more'
                  }}
                </mat-icon>
              </div>
            </th>

            <th (click)="sortBy('mode')" style="width: 170px; text-align: left;">
              <div class="sortable-header col-mode">
                <span>Tipo</span>
                <mat-icon>
                  {{
                    sort.column === 'mode'
                      ? (sort.direction === 'asc' ? 'arrow_upward' : 'arrow_downward')
                      : 'unfold_more'
                  }}
                </mat-icon>
              </div>
            </th>

            <th (click)="sortBy('quantity')" style="width: 100px; text-align: center;">
              <div class="sortable-header col-qty">
                <span>Qtd</span>
                <mat-icon>
                  {{
                    sort.column === 'quantity'
                      ? (sort.direction === 'asc' ? 'arrow_upward' : 'arrow_downward')
                      : 'unfold_more'
                  }}
                </mat-icon>
              </div>
            </th>

            <!-- Sem ordenação -->
            <!--<th>Data</th>-->
            <th class="col-action">Ação</th>
          </tr>
        </thead>
        <tbody class="ml-2">
          <ng-container *ngFor="let item of filteredStock; trackBy: trackByFn">
            <!-- Linha principal -->
            <tr class="main-row table-row" (click)="openStockForm(item, 0)" 
            [ngClass]="{
                  'main-row': true,
                  'alert-validity': shouldShowValidityAlert(item.batch[0]?.validity),
                  'alert-medium': !shouldShowValidityAlert(item.batch[0]?.validity) && getBatchAlertLevel(item.batch[0]) === 'medium',
                  'alert-high': !shouldShowValidityAlert(item.batch[0]?.validity) && getBatchAlertLevel(item.batch[0]) === 'high'
                }"
              >
              <td class="col-id" [attr.rowspan]="item.batch.length">
                <strong>#{{ item.id }}</strong>
                <mat-icon *ngIf="item.stock_entry_blocked" class="lock-icon" matTooltip="Entrada bloqueada para controle do estoque da fazenda.">
                  lock_outline
                </mat-icon>
              </td>
              <td class="col-farm" [attr.rowspan]="item.batch.length">
                {{ item.farm }} <br />
                <small class="stock-date">{{ getBatchDate(item.batch[0]) }}</small>
              </td>
              <td class="col-product" [attr.rowspan]="item.batch.length">
                <span class="product-badge" [ngStyle]="{ 'background-color': getProductColor(item.product?.id) }">
                  <strong>{{ item.product?.description }}</strong>
                </span>
              </td>
              <td class="col-min" [attr.rowspan]="item.batch.length">
                <span>
                  {{ item.minimun_level || '-' }}
                  <mat-icon *ngIf="shouldShowMinAlert(item)" class="alert-icon" matTooltip="Estoque próximo do nível mínimo.">
                    warning
                  </mat-icon>
                </span>
              </td>
              <td class="col-total" [attr.rowspan]="item.batch.length">
                <strong>{{ item.total_stock || '-' }}</strong>
              </td>
              <td class="col-batch">{{ item.batch[0]?.batch || '-' }}</td>
              <td class="col-validity">
                <span>                
                  <mat-icon *ngIf="shouldShowValidityAlert(item.batch[0]?.validity)" class="alert-icon-batch">warning</mat-icon>
                  {{ item.batch[0]?.validity | date : 'dd/MM/yyyy' || '-' }}
                </span> <br />
                <span class="text-sm">                
                  <ng-container *ngIf="getBatchAlertLevel(item.batch[0]) === 'medium'">
                    <mat-icon class="alert-icon" matTooltip="Lote sem atualização há mais de 15 dias.">report_problem</mat-icon>
                  </ng-container>
                  <ng-container *ngIf="getBatchAlertLevel(item.batch[0]) === 'high'">
                    <mat-icon class="alert-icon" matTooltip="Lote sem atualização há 30 dias ou mais.">error</mat-icon>
                  </ng-container>
                  <strong class="text-gray-500">{{ getBatchDate(item.batch[0]) }}</strong>
                </span>
              </td>
              <td class="col-mode">
                <span
                  class="product-badge"
                  [ngStyle]="{ 'background-color': getModeColor(item.batch[0]?.mode) }">
                  <strong>{{ getModeLabel(item.batch[0]?.mode) }}</strong>
                </span>
              </td>
              <td class="col-qty">{{ item.batch[0]?.quantity || '-' }}</td>
              <!--<td class="col-date">
                {{ getBatchDate(item.batch[0]) }}
                <ng-container *ngIf="getBatchAlertLevel(item.batch[0]) === 'medium'">
                  <mat-icon class="alert-icon" matTooltip="Lote sem atualização há mais de 15 dias.">report_problem</mat-icon>
                </ng-container>
                <ng-container *ngIf="getBatchAlertLevel(item.batch[0]) === 'high'">
                  <mat-icon class="alert-icon" matTooltip="Lote sem atualização há 30 dias ou mais.">error</mat-icon>
                </ng-container>
              </td>-->
              <td class="col-action" [attr.rowspan]="item.batch.length" style="vertical-align: middle; text-align: center;">
                <button mat-icon-button color="primary" (click)="openStockForm(item, 0); $event.stopPropagation()" matTooltip="Editar estoque">
                  <mat-icon>edit</mat-icon>
                </button>
              </td>
            </tr>

            <!-- Batches adicionais -->
            <ng-container *ngFor="let batch of item.batch; let j = index">
              <tr *ngIf="j > 0" class="sub-row table-row" (click)="openStockForm(item, j)">
                <td class="col-batch">
                  {{ batch.batch || '-' }}
                  <mat-icon *ngIf="getBatchAlertLevel(batch) === 'medium'" class="alert-icon">report_problem</mat-icon>
                  <mat-icon *ngIf="getBatchAlertLevel(batch) === 'high'" class="alert-icon">error</mat-icon>
                </td>
                <td class="col-validity">
                  <span>
                    <mat-icon *ngIf="shouldShowValidityAlert(batch.validity)" class="alert-icon-batch">warning</mat-icon>
                    {{ batch.validity | date: 'dd/MM/yyyy' || '-' }}                  
                  </span> <br />
                  <span class="text-sm">                  
                    <ng-container *ngIf="getBatchAlertLevel(batch) === 'medium'">
                      <mat-icon class="alert-icon">report_problem</mat-icon>
                    </ng-container>
                    <ng-container *ngIf="getBatchAlertLevel(batch) === 'high'">
                      <mat-icon class="alert-icon">error</mat-icon>
                    </ng-container>
                    <strong class="text-gray-500">{{ getBatchDate(batch) }}</strong>
                  </span>
                </td>
                <td class="col-mode">
                  <span
                    class="product-badge"
                    [ngStyle]="{ 'background-color': getModeColor(batch.mode) }">
                    <strong>{{ getModeLabel(batch.mode) }}</strong>
                  </span>
                </td>
                <td class="col-qty">{{ batch.quantity || '-' }}</td>
                <!--<td class="col-date">
                  {{ getBatchDate(batch) }}
                  <ng-container *ngIf="getBatchAlertLevel(batch) === 'medium'">
                    <mat-icon class="alert-icon">report_problem</mat-icon>
                  </ng-container>
                  <ng-container *ngIf="getBatchAlertLevel(batch) === 'high'">
                    <mat-icon class="alert-icon">error</mat-icon>
                  </ng-container>
                </td> -->           
              </tr>
            </ng-container>
          </ng-container>
        </tbody>
      </table>
    </div>

</div>

<div *ngIf="isMobile" class="stock-list-container ml-2 mr-2 mb-2">
  <!-- Cabeçalho com responsividade -->
  <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-2 px-2 pt-3">
    <div
        class="flex pr-5 md:pr-0 items-center font-sans text-xl text-neutral-500 font-bold">
        <mat-icon class="text-orange-500">inventory_2</mat-icon> &nbsp; <spam class="text-green-700">Estoques </spam>
    </div>   
    <div class="flex flex-col sm:flex-row sm:items-center gap-2">
      <button mat-flat-button color="primary" (click)="switchTab()" class="w-fit" [disabled]="isLoading || isDownloading">
        <mat-icon>dashboard</mat-icon>
        <span class="ml-1">Dashboard Estoques</span>
      </button>
    </div>
    <div class="flex flex-col sm:flex-row sm:items-center gap-2">
      <button mat-flat-button color="primary" (click)="downloadStock()" class="w-fit" [disabled]="isLoading || isDownloading">
        <mat-icon>cloud_download</mat-icon>
      </button>
      <button mat-flat-button color="primary" (click)="openFilterDialog()" class="w-fit" [disabled]="isLoading || isDownloading">
        <mat-icon>search</mat-icon>
        <span class="ml-1">Filtrar</span>
      </button>
      <button mat-flat-button color="primary" (click)="createNewStock()" class="w-fit" [disabled]="isLoading || isDownloading">
        <mat-icon>add</mat-icon>
        <span class="ml-1">Criar Novo Estoque</span>
      </button>
    </div>
  </div>

  <div class="busca-legenda-container shadow-sm rounded-lg bg-white px-4 py-4 mt-4 mb-4">

    <div
        *ngIf="filteredStock.length > 0" class="flex pr-5 md:pr-0 items-center font-sans text-sm text-neutral-500 mt-3 ml-2">
          ✔️ Estoques encontrados: &nbsp; <spam class="text-green-700"><strong>{{ filteredStock.length }}</strong></spam>
    </div>  
    <div
        *ngIf="filteredStock.length === 0" class="flex pr-5 md:pr-0 items-center font-sans text-sm text-neutral-500 mt-3 ml-2">
        ❕ Estoques encontrados: &nbsp; <spam class="text-gray-700"><strong>{{ filteredStock.length }}</strong></spam>
    </div>    

    <!-- Barra de busca -->
    <div class="mt-2 px-2 -mb-2">
      <mat-form-field appearance="outline" class="w-[300px] max-w-full" floatLabel="never">
        <mat-label>Buscar</mat-label>
        <input matInput [(ngModel)]="searchTerm" placeholder="Digite para filtrar..." />
        <button mat-icon-button *ngIf="searchTerm" matSuffix (click)="searchTerm=''">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </div>

    <!-- Legenda dos alertas -->
    <div class="px-2 text-sm text-gray-700">
      <div class="font-semibold mb-2 text-green-700">Legenda de Alertas</div>
      <div class="flex flex-col gap-2">
        
        <div class="flex items-center gap-2">
          <mat-icon class="text-yellow-500">report_problem</mat-icon>
          <span>** Atenção</span>
        </div>

        <div class="flex items-center gap-2">
          <mat-icon class="text-yellow-600">error</mat-icon>
          <span>Atualização há mais de 30 dias</span>
        </div>

        <div class="flex items-center gap-2">
          <mat-icon class="text-red-600">warning</mat-icon>
          <span>Validade próxima ou vencida</span>
        </div>

        <div class="flex items-center gap-2">
          <div class="w-4 h-4 rounded-sm border-l-4 border-red-600 bg-red-100"></div>
          <span>Linha com validade crítica</span>
        </div>

        <div class="flex items-center gap-2">
          <div class="w-4 h-4 rounded-sm border-l-4 border-yellow-400 bg-yellow-100"></div>
          <span>Linha sem atualização há 15+ dias</span>
        </div>

        <div class="flex items-center gap-2">
          <div class="w-4 h-4 rounded-sm border-l-4 border-yellow-600 bg-yellow-200"></div>
          <span>Linha sem atualização há 30+ dias</span>
        </div>
      </div>
    </div>

  </div>


  <mat-progress-bar *ngIf="isDownloading || isLoading" mode="indeterminate" class="w-full"></mat-progress-bar>

  <hr class="-mt-1 -mb-1 border-green-600" />

  <!-- Lista de estoques em cards -->
  <div class="flex flex-col gap-4 mt-4">
    <div *ngFor="let item of filteredStock; trackBy: trackByFn"
      class="rounded-xl border shadow p-4 bg-white relative cursor-pointer"
      (click)="openStockForm(item, 0)"
      [ngClass]="{
        'alert-validity': shouldShowValidityAlert(item.batch[0]?.validity),
        'alert-medium': !shouldShowValidityAlert(item.batch[0]?.validity) && getBatchAlertLevel(item.batch[0]) === 'medium',
        'alert-high': !shouldShowValidityAlert(item.batch[0]?.validity) && getBatchAlertLevel(item.batch[0]) === 'high'
      }">

      <!-- ID e ação -->
      <div class="flex items-center justify-between">
        <div class="text-base font-semibold text-gray-800 flex items-center gap-1">
          #{{ item.id }}
          <mat-icon *ngIf="item.stock_entry_blocked" class="text-red-600" matTooltip="Entrada bloqueada para controle do estoque da fazenda.">
            lock_outline
          </mat-icon>
        </div>
        <button mat-icon-button (click)="openStockForm(item, 0); $event.stopPropagation()">
          <mat-icon>edit</mat-icon>
        </button>
      </div>

      <!-- Produto -->
      <div class="mt-2">
        <div class="text-sm font-medium text-gray-500">Produto</div>
        <div
          class="text-sm font-bold rounded-lg px-2 py-1 inline-block text-white"
          [ngStyle]="{ 'background-color': getProductColor(item.product?.id) }">
          {{ item.product?.description || '-' }}
        </div>
      </div>

      <!-- Informações gerais -->
      <div class="mt-2 grid grid-cols-2 gap-2">
        <div>
          <div class="text-xs text-gray-500">Fazenda</div>
          <div class="text-sm">{{ item.farm }}</div>
        </div>
        <div>
          <div class="text-xs text-gray-500">Estoque Total</div>
          <div class="text-sm font-medium"><strong>{{ item.total_stock || '-' }}</strong></div>
        </div>
        <div>
          <div class="text-xs text-gray-500">Nível Mínimo</div>
          <div class="text-sm flex items-center">
            <strong>{{ item.minimun_level || '-' }}</strong>
            <mat-icon *ngIf="shouldShowMinAlert(item)" class="text-yellow-600 ml-1" matTooltip="Estoque próximo do mínimo">
              warning
            </mat-icon>
          </div>
        </div>
        <div>
          <div class="text-xs text-gray-500">Data</div>
          <div class="text-sm">{{ getBatchDate(item.batch[0]) }}</div>
        </div>
      </div>

      <!-- Lotes -->
      <div class="mt-4">
        <div class="text-sm font-semibold mb-1">Lotes</div>
        <div *ngFor="let batch of item.batch"
          class="relative border-l-4 rounded-md p-2 mb-2 hover:bg-gray-50 cursor-pointer"
          (click)="openStockForm(item, item.batch.indexOf(batch)); $event.stopPropagation()"
          [ngClass]="{
            'border-red-600 bg-red-100 hover:bg-red-200': shouldShowValidityAlert(batch.validity),
            'border-yellow-600 bg-yellow-200 hover:bg-yellow-300': getBatchAlertLevel(batch) === 'high' && !shouldShowValidityAlert(batch.validity),
            'border-yellow-400 bg-yellow-100 hover:bg-yellow-200': getBatchAlertLevel(batch) === 'medium' && !shouldShowValidityAlert(batch.validity),
            'border-green-600 bg-green-50 hover:bg-green-100': getBatchAlertLevel(batch) === 'none' && !shouldShowValidityAlert(batch.validity)
          }">

          <div class="flex justify-between items-center">
            <div class="text-sm font-medium">{{ batch.batch || '-' }}</div>
            <div class="text-xs text-gray-500">Validade: <strong>{{ batch.validity | date: 'dd/MM/yyyy' }}</strong></div>
          </div>
          <div class="flex justify-between mt-1">            
            <div class="text-xs text-gray-600">
              <span
                  class="product-badge-mobile"
                  [ngStyle]="{ 'background-color': getModeColor(batch.mode) }">
                  <strong>{{ getModeLabel(batch.mode) }}</strong>
              </span>
            </div>
            <div class="text-xs text-gray-600">Qtd: <strong>{{ batch.quantity || '-' }}</strong></div>
          </div>
          <div class="flex gap-1 mt-1 items-center">
            <mat-icon *ngIf="shouldShowValidityAlert(batch.validity)" class="text-red-600" matTooltip="Validade próxima ou vencida">
              warning
            </mat-icon>
            <mat-icon *ngIf="getBatchAlertLevel(batch) === 'medium'" class="text-yellow-500" matTooltip="Lote sem atualização há mais de 15 dias">
              report_problem
            </mat-icon>
            <mat-icon *ngIf="getBatchAlertLevel(batch) === 'high'" class="text-yellow-600" matTooltip="Lote sem atualização há 30 dias ou mais">
              error
            </mat-icon>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

